import {CanvasSource, DOMAdapter, Texture} from 'pixi.js';

const neutralTextures = new WeakMap();
const flatTextures = new WeakMap();

// A copy of a texture with its pixels rewritten, made once per source image.
const remapped = (texture, cache, remap) => {
    const resource = texture.source.resource;
    if (!resource) return texture;
    const cached = cache.get(texture);
    if (cached?.resource === resource) return cached.texture;
    const {frame} = texture;
    const canvas = DOMAdapter.get().createCanvas(frame.width, frame.height);
    canvas.width = frame.width;
    canvas.height = frame.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(resource, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);
    const image = ctx.getImageData(0, 0, canvas.width, canvas.height);
    remap(image.data);
    ctx.putImageData(image, 0, 0);
    const result = new Texture({source: new CanvasSource({resource: canvas}), orig: texture.orig, trim: texture.trim});
    cache.set(texture, {resource, texture: result});
    return result;
};

// Blood clouds and stains have red baked into their art. Remove that hue once
// per source image so a green tint can stay green, preserving alpha and shading.
export function neutralBloodTexture(texture) {
    return remapped(texture, neutralTextures, data => {
        for (let i = 0; i < data.length; i += 4) {
            const shade = Math.min(255, Math.round(Math.max(data[i], data[i + 1], data[i + 2]) * 255 / 201));
            data[i] = data[i + 1] = data[i + 2] = shade;
        }
    });
}

// Paint and juice keep their tint exactly, white included: only the shape, in white.
export function flatStainTexture(texture) {
    return remapped(texture, flatTextures, data => {
        for (let i = 0; i < data.length; i += 4) data[i] = data[i + 1] = data[i + 2] = 255;
    });
}
